// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal de reportes de terrestre (PENDIENTES_TERRESTRE, punto 8; 13-oct-2026) */
.ReportModal_body__TfR6K {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: min(520px, 80vw);
}

.ReportModal_sectionTitle__vpCeU {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 700;
  color: var(--dylo-ink);
}

.ReportModal_muted__w-eEn {
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--dylo-muted);
}

.ReportModal_filters__j3ze2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 10px 12px;
  background: var(--dylo-field-bg);
  border: 1px solid var(--dylo-line);
  border-radius: 10px;
}

.ReportModal_filterRow__ujXuN {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 10px;
  align-items: baseline;
}

.ReportModal_filterLabel__hplaP {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--dylo-ink);
}

.ReportModal_filterValues__EqBbu {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
}

.ReportModal_chip__zSGmx {
  display: inline-flex;
  align-items: center;
  padding: 2px 9px;
  border-radius: 999px;
  border: 1px solid var(--dylo-field-border);
  background: var(--dylo-surface);
  font-size: 12px;
  color: var(--dylo-text);
}

.ReportModal_total__rSXh4 {
  margin: 8px 0 0;
  font-size: 12.5px;
  color: var(--dylo-muted);
}

.ReportModal_options__dXPCf {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ReportModal_option__WZeuV {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border: 1px solid var(--dylo-line);
  border-radius: 10px;
}

.ReportModal_optionText__BY5Vt {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
}

.ReportModal_optionTitle__2\\+Gtj {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--dylo-ink);
}

.ReportModal_optionBtn__0wCBy {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.ReportModal_error__-k5sj {
  margin: 0;
  padding: 9px 12px;
  border: 1px solid color-mix(in srgb, #e5484d 45%, transparent);
  border-radius: 8px;
  background: color-mix(in srgb, #e5484d 10%, transparent);
  font-size: 12.5px;
  line-height: 1.55;
  color: var(--dylo-text);
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Loads/components/ReportModal.module.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,8DAA8D;EAC9D,kBAAkB;EAClB,wDAAwD;EACxD,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB","sourcesContent":["/* Modal de reportes de terrestre (PENDIENTES_TERRESTRE, punto 8; 13-oct-2026) */\n.body {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  min-width: min(520px, 80vw);\n}\n\n.sectionTitle {\n  margin: 0 0 8px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n}\n\n.muted {\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--dylo-muted);\n}\n\n.filters {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 10px 12px;\n  background: var(--dylo-field-bg);\n  border: 1px solid var(--dylo-line);\n  border-radius: 10px;\n}\n\n.filterRow {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 10px;\n  align-items: baseline;\n}\n\n.filterLabel {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n}\n\n.filterValues {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 0;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 9px;\n  border-radius: 999px;\n  border: 1px solid var(--dylo-field-border);\n  background: var(--dylo-surface);\n  font-size: 12px;\n  color: var(--dylo-text);\n}\n\n.total {\n  margin: 8px 0 0;\n  font-size: 12.5px;\n  color: var(--dylo-muted);\n}\n\n.options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.option {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px;\n  border: 1px solid var(--dylo-line);\n  border-radius: 10px;\n}\n\n.optionText {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex: 1;\n}\n\n.optionTitle {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n}\n\n.optionBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.error {\n  margin: 0;\n  padding: 9px 12px;\n  border: 1px solid color-mix(in srgb, #e5484d 45%, transparent);\n  border-radius: 8px;\n  background: color-mix(in srgb, #e5484d 10%, transparent);\n  font-size: 12.5px;\n  line-height: 1.55;\n  color: var(--dylo-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `ReportModal_body__TfR6K`,
	"sectionTitle": `ReportModal_sectionTitle__vpCeU`,
	"muted": `ReportModal_muted__w-eEn`,
	"filters": `ReportModal_filters__j3ze2`,
	"filterRow": `ReportModal_filterRow__ujXuN`,
	"filterLabel": `ReportModal_filterLabel__hplaP`,
	"filterValues": `ReportModal_filterValues__EqBbu`,
	"chip": `ReportModal_chip__zSGmx`,
	"total": `ReportModal_total__rSXh4`,
	"options": `ReportModal_options__dXPCf`,
	"option": `ReportModal_option__WZeuV`,
	"optionText": `ReportModal_optionText__BY5Vt`,
	"optionTitle": `ReportModal_optionTitle__2+Gtj`,
	"optionBtn": `ReportModal_optionBtn__0wCBy`,
	"error": `ReportModal_error__-k5sj`
};
export default ___CSS_LOADER_EXPORT___;
